import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/the-woodlands")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in The Woodlands, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for The Woodlands & Montgomery County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — The Woodlands, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving The Woodlands and Montgomery County.",
      keywords: "awnings The Woodlands, awning company The Woodlands, custom awnings The Woodlands, sail shades The Woodlands, patio covers The Woodlands, pergola covers The Woodlands, metal awnings The Woodlands, canvas awnings The Woodlands, Texas Made Shade",
    }),
    scripts: cityHeadScripts("The Woodlands", "Montgomery County"),
  }),
  component: () => <CityHomePage city="The Woodlands" region="Montgomery County" />,
});
